import DataValid from './DataValid';
import FGTSInstallments from './FGTSInstallments';
import ModalStep from './ModalStep';
import Pendencies from './Pendencies';
import UpdateBirthDate from './UpdateBirthDate';
import UpdateContractNumber from './UpdateContractNumber';

export const CONTRACT_FIELDS_MODALS = [
  DataValid,
  FGTSInstallments,
  ModalStep,
  Pendencies,
  UpdateBirthDate,
  UpdateContractNumber,
];

// mantém compatibilidade com ContractDetails.tsx que usa CONTRACT_DETAIL_MODALS
export const CONTRACT_DETAIL_MODALS = CONTRACT_FIELDS_MODALS;

export default {
  ModalStep,
  FGTSInstallments,
  DataValid,
  UpdateBirthDate,
  UpdateContractNumber,
  Pendencies,
};
